module.exports = __webpack_public_path__ + "static/media/rollup-blue.d9268174.svg";